module.exports = __webpack_public_path__ + "img/map.c216d309.svg";